import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { columnAvatarConfig, columnAvatarString, EntityMainNameDefault, swivuGridSorterFn } from "../../other/utils/utils.jsx";
import ColumnBase from "./ColumnBase.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";

export default class NotifyTabUserColumn extends ColumnBase {
  static get $name() {
    return "NotifyTabUserColumn";
  }

  static get fields() {
    return [
      { name: "swivuListTitle", readOnly: true, type: "string", defaultValue: "Ownership"  },
      { name: "canMultiSelectSwivuList", readOnly: true, defaultValue: true },
      { name: "swivuListSearchKey", readOnly: true, defaultValue: "name" },
    ];
  }

  static get type() {
    return WIDGET_KEYS.notifyTabUserColumn;
  }

  static get defaults() {
    return {
      field: "values",
      editor: false,
      autoHeight: true,
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      flex: 1,
      tooltipRenderer: columnAvatarConfig.tooltipRenderer
    };
  }

  get swivuListItems() {
    return this.project
      .getCrudStore(STORE_KEYS.boardUserStore)
      .query(() => true, true).sort(swivuGridSorterFn.bind({ field: "name" })) || [];
  }

  onLoad(project, { swivuTab }) {
    this.project = project;
    this.swivuTab = swivuTab;
  }

  renderer({ record, size }) {
    const { id } = record;
    const boardUserRecords = record.values.map(boardUserId => this.project.boardUsersStore.getById(boardUserId));
    return boardUserRecords.length > 0 ? boardUserRecords.map(record => columnAvatarConfig.columnAvatarRenderer({
      image: record.profileImageURL,
      name: record.name,
      size: size.configuredHeight,
      archived: record.archived,
      showName: false,
      containerConfig: {
        class: "relative group !h-max"
      },
      otherConfig: {
        tag: "button",
        class: `${this.swivuTab.SWIVU_NOTIFY_REMOVE_BUTTON_CLS} bg-destructive absolute top-0 -right-1 rounded-full h-4 w-4 hidden items-center justify-center text-xs group-hover:flex`,
        dataset: {
          gridRecordId: id,
          boardUserId: record.id,
        },
        children: [
          { tag: "i", class: "fa fa-times !text-destructive-foreground leading-[.8] pointer-events-none" }
        ]
      }
    })) : EntityMainNameDefault();
  }

  getSwivuListItemDisplayValue(record) {
    return columnAvatarString(record.name, record.profileImageURL);
  }

  getSelectedSwivuListItem(record) {
    return this.swivuListItems.filter((item) =>
      record.values.includes(item.id)
    );
  }

  onSwivuListSelectionChange(record, boardUserRecords, _editor, selectedRecord, action) {
    this.swivuTab.handleSwivuRecordUpdate({
      notifyType: record.type,
      newBoardUserIds: boardUserRecords.map(record => record.id),
      updatedBoardUserId: selectedRecord.id,
      action: action === "select" ? "add" : "remove"
    });
    record.values = boardUserRecords.map(record => record.id); // Update internal record being used in the entity tag editor throught his column
  }
}

ColumnStore.registerColumnType(NotifyTabUserColumn);
